import React from 'react'

export default function ShareIcon(props) {


    return (
        <>
            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.80488 9.47059L6.2439 9.47059C4.96359 9.47007 3.7075 9.83882 2.61141 10.537C1.51533 11.2351 0.620957 12.2361 0.0249767 13.4318C0.00822477 13.2099 -0.000107147 12.9873 1.04009e-06 12.7647C1.04009e-06 8.21635 3.49424 4.52941 7.80488 4.52941L7.80488 0L16 7L7.80488 14L7.80488 9.47059ZM6.2439 7.82353H9.36585V10.5478L13.5188 7L9.36585 3.45224V6.17647H7.80488C6.90751 6.17541 6.02052 6.37891 5.2046 6.77305C4.38867 7.1672 3.66308 7.74268 3.07746 8.46012C4.08532 8.03865 5.15978 7.82264 6.2439 7.82353Z" fill="white" />
                <path d="M7.80488 9.47059L6.2439 9.47059C4.96359 9.47007 3.7075 9.83882 2.61141 10.537C1.51533 11.2351 0.620957 12.2361 0.0249767 13.4318C0.00822477 13.2099 -0.000107147 12.9873 1.04009e-06 12.7647C1.04009e-06 8.21635 3.49424 4.52941 7.80488 4.52941L7.80488 0L16 7L7.80488 14L7.80488 9.47059ZM6.2439 7.82353H9.36585V10.5478L13.5188 7L9.36585 3.45224V6.17647H7.80488C6.90751 6.17541 6.02052 6.37891 5.2046 6.77305C4.38867 7.1672 3.66308 7.74268 3.07746 8.46012C4.08532 8.03865 5.15978 7.82264 6.2439 7.82353Z" fill="#4E5D78" />
            </svg>

        </>
    )
}
